class AddOns extends HTMLElement {
  constructor() {
    super();
    this.openPopupButtons = this.querySelectorAll(".js-open-popup");
    this.closePopupButtons = this.querySelectorAll(".js-close-popup");
    this.radioChecks = this.querySelectorAll(".js-radio");
    this.productQuantitys = this.querySelectorAll(".js-quantity");
    this.formData = { items: [] };
    this.init();
  }

  init() {
    this.style.display = "none";
    
    window.addEventListener("customily-preview-load-finished", (function(t) {
      this.style.display = "block";
    }).bind(this));

    this.openPopupButtons.forEach((function(t) {
      t.addEventListener("click", this.initOpen.bind(t));
    }).bind(this));

    this.closePopupButtons.forEach((function(t) {
      t.addEventListener("click", this.initClose.bind(t));
    }).bind(this));

    this.radioChecks.forEach((function(t) {
      t.querySelector("input").value;
      t.closest(".add-ons__controller").querySelector(".product-quantity");
      if (t.classList.contains("default")) {
        t.querySelector("input").checked = true;
        t.querySelector("label").click();
      }
      t.addEventListener("click", this.initRadioCheck.bind(this, t));
    }).bind(this));

    this.productQuantitys.forEach((function(t) {
      t.addEventListener("change", this.initUpdateQuantity.bind(this, t));
    }).bind(this));
  }

  initOpen() {
    this.parentElement.parentElement.querySelector(".add-ons__preview-product").classList.add("active");
    document.body.classList.add("overflow-hidden");
    document.querySelector("main").classList.add("opening-add-ons-modal");
  }

  initClose() {
    let t = this.parentElement.parentElement;
    if (this.classList.contains("add-ons__modal-background")) {
      t = this.parentElement;
      t.classList.remove("active");
    } else {
      t = this.closest(".add-ons__preview-product");
      t.classList.remove("active");
    }
    document.body.classList.remove("overflow-hidden");
    document.querySelector("main").classList.remove("opening-add-ons-modal");
    document.querySelector(".container__top-part").classList.remove("opening-add-ons-modal");
  }

  initRadioCheck(t) {
    let e = t.parentElement.parentElement.querySelector(".product-quantity");
    let i = 0;
    let s = t.querySelector("input").value;
    
    if (s != "") {
      e.style.display = "block";
      i = Number(e.querySelector("select").value);
      if (this.formData.items.find(({id: o}) => o === s) === undefined) {
        this.formData.items.push({id: Number(s), quantity: i});
      }
    } else {
      e.style.display = "none";
      this.formData.items.splice(this.formData.items.findIndex(l => l.id === s), 1);
    }
  }

  initUpdateQuantity(t) {
    let n = Number(t.value);
    let e = Number(t.dataset.variantId);
    this.formData.items.find(function(i) {
      if (i.id === e) {
        i.quantity = n;
      }
    });
  }

  formSubmit() {
    return this.formData.items;
  }
}

customElements.define("add-ons", AddOns);
